import { gql } from "@apollo/client";

// Admin-only readout of the current A/B experiment. Returns a JSON blob
// ({ meta, sections }) so the backend can change sections/columns without
// touching this client.
export const AB_REPORT = gql`
  query AbReport($from: String, $to: String) {
    abReport(from: $from, to: $to)
  }
`;
